import { Model } from '@appstrax/services/database';

export type PhoneCallDirection = 'inbound' | 'outbound';
export type PhoneCallChannel = 'phone' | 'whatsapp' | 'unknown';
export type PhoneCallStatus = 'queued' | 'in_progress' | 'completed' | 'failed' | 'cancelled';

/**
 * Record of a voice/phone call (future: WhatsApp voice agent, Twilio, etc).
 * Stored so users can audit what was requested and what happened.
 */
export class PhoneCallRecord extends Model {
  public organizationId?: string;
  public projectId?: string;
  public userId?: string;

  public channel: PhoneCallChannel = 'unknown';
  public direction: PhoneCallDirection = 'inbound';
  public status: PhoneCallStatus = 'completed';

  public from?: string;
  public to?: string;

  /** Numeric timestamp (ms) to match other models like AppNotification */
  public startedAt: number = Date.now();
  public endedAt?: number;
  public durationSec?: number;

  public summary?: string;
  public transcript?: string;
  public recordingUrl?: string;

  /** Freeform payload for provider-specific metadata (Twilio callSid, etc) */
  public meta: any = {};
}

